var map = {
	"./shouye-daili-png-02.svg": "243d",
	"./shouye-fuhua-png-02.svg": "9d67",
	"./shouye-xiangmuzhichi-png-02.svg": "da35",
	"./shouye-zixun-png-02.svg": "f51f",
	"./shouye-zizhi-png-02.svg": "77c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "73f7";